import {
  createCatalogEndpoint,
  createCrudEndpoints,
  createNestedCrudEndpoints,
} from '@/core/utils'
import {
  TInventoryTransfer,
  TInventoryTransferDetail,
  TWarehouse,
  TStock,
} from '.'
import { DataWithPagination, TBaseHistoryActions } from '@/core/types'
import { TLocation } from '../locations'
import { MaybeRef } from 'vue'
import api from '@/core/config/axios'

export type TInventoryTransfers = DataWithPagination<TInventoryTransfer>

export const serviceConfig = {
  model: 'inventory-transfers',
  version: 'v1',
  details: {
    model: 'details',
    version: 'v1',
  },
  catalogs: {
    warehouses: {
      model: 'warehouses',
      version: 'v1',
    },
    stock: {
      model: 'stock',
      version: 'v1',
    },
    locations: {
      model: 'locations',
      version: 'v1',
    },
  },
}

const { warehouses, stock, locations } = serviceConfig.catalogs
const { model: modelDetails, version: versionDetails } = serviceConfig.details

const moduleServiceHandlers = {
  ...createCrudEndpoints<TInventoryTransfers, TInventoryTransfer>(
    serviceConfig.model,
    serviceConfig.version,
  ),
  loadHistoryActions: async (payload: {
    id?: MaybeRef<number | string>
  }): Promise<Partial<TBaseHistoryActions>[]> =>
    api
      .get(
        `${serviceConfig.version ?? ''}/${serviceConfig.model}/${
          payload.id
        }/history-actions`,
      )
      .then((response) => response.data),
}

const moduleDetailServiceHandlers = createNestedCrudEndpoints<
  TInventoryTransferDetail[],
  TInventoryTransferDetail
>(serviceConfig.model, modelDetails, versionDetails)

const warehouseCatalog = createCatalogEndpoint<TWarehouse[]>(
  warehouses.model,
  warehouses.version,
)
const locationsCatalog = createCatalogEndpoint<TLocation[]>(
  locations.model,
  locations.version,
)

const stockCatalog = createCatalogEndpoint<TStock[]>(stock.model, stock.version)

const catalogServiceHandlers = {
  warehouseCatalog,
  stockCatalog,
  locationsCatalog,
}

export {
  moduleServiceHandlers,
  catalogServiceHandlers,
  moduleDetailServiceHandlers,
}
